import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import { Row, Col, Container, Card, Image } from 'react-bootstrap'
import sp from '../images/htt500x500.png';
import safetycheck from '../images/safety_check_station.png';
import dotcheck from '../images/dot_inspection_station.png';
function Services() {
    return (
        <div>
            <TopMenu />
            <Container>
                <h2 className='htitleb text-center'>Services</h2>
                <p>
                    The HT&T Service Department maintains one of the most fully-equipped shops on Oahu and offers a full range of mechanical, electrical, and body repair services. The Service Department is equipped to service any truck, from a light pickup to a heavy-duty class 8, and we handle all factory authorized warranty repairs on Peterbilt, Isuzu and McNeilus, plus all major OEM components. Utilizing the latest technology to help us identify and fix the problem with greater efficiency, our technicians are trained to work on all makes and models. Service facilities include six covered service bays, a body shop and a full-service paint booth.</p>
                <Row className=''>
                    <Col md={3}>
                        <Image src={safetycheck} />
                    </Col>
                    <Col md={3}>
                        <Image src={dotcheck} />
                    </Col>
                    <Col md={6}>
                        <h4 className='htitleb text-center'>Service Department</h4>
                        <hr />
                        <Row className='justify-content-center'>
                            <Col md={3}>
                                <h5 className='titleb text-center'>Hours</h5>
                                <p className='text-center'>Monday - Friday (Closed Weekend) <br /> 7:00 AM - 3:30 PM</p>

                            </Col>
                            <Col md={3}>
                                <h4 className='titleb text-center'>Contact</h4>
                                <p className='text-center'> (808) 532-7512</p>
                            </Col>
                        </Row>
                        <Row>

                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Card id="service-card">
                            <Container>
                                <Row>
                                    <Col md={3}>
                                        <Image src={sp} fluid style={{
                                            width: '100%'
                                        }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-center'>
                                        <div className='htitleb' style={{
                                            fontSize: '30px'
                                        }}>


                                            Less Down Time
                                        </div>
                                    </Col>
                                </Row>
                                <hr></hr>
                                <p>Our preventative maintenance program includes an [80]-point
                                    inspection to identify and fix any problems that may occur.
                                    This will reduce unexpected breakdowns and help to reduce your down time.
                                    In addition, every time we service a truck we check for any outstanding recalls
                                    issued by the factory and address the issue.
                                    We also process your warranty claims, saving you headaches and, more importantly, time.
                                </p>
                            </Container>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card id="service-card">
                            <Container>
                                <Row>
                                    <Col md={3}>
                                        <Image src={sp} fluid style={{
                                            width: '100%'
                                        }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-center'>
                                        <div className='htitleb' style={{
                                            fontSize: '30px'
                                        }}>
                                            100% Genuine Peterbilt
                                        </div>
                                    </Col>
                                </Row>
                                <hr></hr>
                                <p>When you come to HT&T, you can be confident that we know your truck
                                    better than anyone else. We are a Peterbilt exclusive dealer and our
                                    technicians are factory-trained with years of experience working on
                                    trucks just like yours. We use certified OEM parts when we repair your
                                    truck and with Hawaii’s only Peterbilt parts inventory, we have most
                                    parts already in stock so that we can get you back on the road faster.
                                </p>
                            </Container>

                        </Card>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={6}>
                        <Card id="service-card">
                            <Container>
                                <Row>
                                    <Col md={3}>
                                        <Image src={sp} fluid style={{
                                            width: '100%'
                                        }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-center'>
                                        <div className='htitleb' style={{
                                            fontSize: '30px'
                                        }}>
                                            Unparalleled Service
                                        </div>
                                    </Col>
                                </Row>
                                <hr></hr>
                                <p>Nowhere else will you find the commitment to service and customer satisfaction
                                    like HT&T Truck Center. If you need to wait while your vehicle is serviced, we
                                    provide a friendly and clean atmosphere where you can feel comfortable and relaxed.
                                    You have the option of waiting in our customer lounge and enjoying the fresh coffee and
                                    snacks we have to offer. Or just relax on the sofa while reading the newspaper or the latest
                                    trucking magazine.
                                </p>
                            </Container>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card id="service-card">
                            <Container>
                                <Row>
                                    <Col md={3}>
                                        <Image src={sp} fluid style={{
                                            width: '100%'
                                        }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-center'>
                                        <div className='htitleb' style={{
                                            fontSize: '30px'
                                        }}>
                                            Warranty
                                        </div>
                                    </Col>
                                </Row>
                                <hr></hr>
                                <p>***NEED TO UPDATE** Nowhere else will you find the commitment to service and customer satisfaction like HT&T Truck Center. If you need to wait while your vehicle is serviced, we provide a friendly and clean atmosphere where you can feel comfortable and relaxed. You have the option of waiting in our customer lounge and enjoying the fresh coffee and snacks we have to offer. Or just relax on the sofa while reading the newspaper or the latest trucking magazine.

                                </p>
                            </Container>

                        </Card>
                    </Col>
                </Row>
            </Container>
            <br />
            <BottomMenu />
        </div>
    );
}

export default Services;